<div class="container">
    <div class="file-upload border-dashed" *ngIf="!isPublicUpload" appUploadDropBox [dropCB]="onDrop">
        <ng-container *ngTemplateOutlet="uploadContentTemplate"></ng-container>
    </div>
    <div class="file-upload border-dashed" *ngIf="isPublicUpload" appUploadPublicDropBox [dropCB]="onDrop">
        <ng-container *ngTemplateOutlet="uploadContentTemplate"></ng-container>
    </div>
</div>
<ng-template #uploadContentTemplate>
    <span class="subtitle-1">Drag and drop your files or folders here</span>
    <span class="body-2">or</span>
    <input type="file" multiple #uploadInput (change)="onFileSelected($event)" style="display: none;" />
    <div class="action-buttons">
        <sync-button label="Browse files" type="outlined"
            color="default"
            size="small"
            [leadAdornment]="true"
            leadIconAdornment="upload"
            [onClick]="onUploadButtonClick"></sync-button>
    </div>
    <div class="body-2">Uploads secured by Sync</div>
</ng-template>